import { useAppSelector } from 'js/store/hooks';
import { useGameUrlFragment } from '../../../components/common/Game/hooks';
import { prop } from 'ramda';

export const useGameLink = (code:string) => {
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const gameLinkTag = dynamicTags.DTAG_GAMEINFO_POPUP_LINK;
    const gameLink = gameLinkTag || '/online-game';
    const gameUrlFragment = useGameUrlFragment(code);
    const fullGameLink = `${gameLink}/${gameUrlFragment}`;
    return {
        gameLink,
        gameUrlFragment,
        fullGameLink
    };
};
